import Cookies from 'js-cookie'

const TokenKey = 'jwt'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey)
  return Cookies.remove(TokenKey, { path: '', domain: '' }) // 删除总台cookie
}
